import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';

export default class SelectBox extends Component {
  constructor(props) {
    super(props);

    let existingContentObject = this.props.options.find((option) => option.value === this.props.existingContent);
    let firstOptionValue = undefined;
    if (this.props.options.length) {
        firstOptionValue = this.props.options.find(s => s.selected === true) ?
            this.props.options.find(s => s.selected === true).value :
            this.props.options[0].value;
    }

    this.state = {
      options: this.props.options,
      selectedValue: (existingContentObject) ? this.props.existingContent : firstOptionValue
    };
  }

  focus() {
    this[`${this.props.id}__select`].focus();
  }

  hasFocus() {
    return this[`${this.props.id}__select`] === document.activeElement;
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.options.length !== this.state.options.length ||
      ('existingContent' in newProps &&
        newProps.existingContent !== undefined &&
        newProps.existingContent !== this.state.selectedValue)) {

      let existingContentObject = newProps.options.find((option) => option.value === newProps.existingContent);

      let firstOptionValue = (this.props.options.length) ?
        this.props.options[0].value :
        undefined;

      let selectedValue = (existingContentObject) ? newProps.existingContent : firstOptionValue;

      this.setState({ options: newProps.options, selectedValue });
    }
  }

  getValue = () => {
    if (this.props.required && !this.state.selectedValue) {
      throw new InputError(this.props.label + " is Required", this.state.selectedValue);
    }

    return this.state.selectedValue;
  }

  onChange = (e) => {
    this.setState({ selectedValue: e.target.value }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.selectedValue);
        this.doValidation();
      }
    });
  }

  handleBlur = (e) => {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
    this.doValidation();
  }

  doValidation = () => {
    let newErrorMessage = null;
    if (this.props.validateOnBlur) {
      if (this.props.required) {
        if (!this.state.selectedValue || this.state.selectedValue === this.props.options[0].name) {
          newErrorMessage = (this.props.requiredError) ?
            this.props.requiredError :
            this.props.label + " is a required field.";
        }
      }
      if (newErrorMessage) {
        this.setState({ className: this.props.validationErrorClass });
      }

      this.setState({
        validationError: newErrorMessage,
        contentWrapperClass: newErrorMessage ? this.props.validationErrorClass : ''
      });
    }
  }

  render() {
    let label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> : null;

    let requiredFieldIndicator = (this.props.required) ?
      <abbr title="This field is required"></abbr> :
      null;

    let helperText = this.props.helperText ?
        <span className="helper-text">
          {this.props.helperText}
        </span> :
        null;

    let errorText = this.props.errorMessage;
    if (!errorText && this.state.validationError) {
      errorText = this.state.validationError;
    }
    let errorMessage = errorText ?
      <span className="error-message">
        {errorText}
      </span> :
      null;

    const optionsList = this.props.options.map((option, index) =>
      <option key={index} value={option.value}>
        {option.name}
      </option>
    );

    let selectedValueName = null;

    if (this.state.selectedValue) {
      let selectedValueObject = this.props.options.find((option) => option.value === this.state.selectedValue);
      if (!selectedValueObject) {
        selectedValueObject = this.props.options.find((option) => option.name === this.state.selectedValue);
      }
      selectedValueName = selectedValueObject.name;
    }

    let inputDisplay = null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let contentWrapperClass = this.props.contentWrapperClass;
    if (this.state.contentWrapperClass) {
      contentWrapperClass = this.state.contentWrapperClass;
    }
    verticalSpacingClass += " " + contentWrapperClass;

    if (optionsList.length) {
      inputDisplay = (this.props.isEditable) ?
        <div className={verticalSpacingClass}>
          <div className="label-wrapper">
            {label}
            {requiredFieldIndicator}
          </div>
          <select
            id={this.props.id}
            value={this.state.selectedValue}
            required={this.props.required}
            disabled={this.props.disabled}
            onBlur={this.handleBlur}
            onChange={this.onChange}
            className={this.props.className}
            ref={instance => { this[`${this.props.id}__select`] = instance; }}
          >
            {optionsList}
          </select>
          {helperText}
          {errorMessage}
        </div> :
        <div className={verticalSpacingClass}>
          {label}
          <div className="read-only">
            {selectedValueName}
          </div>
        </div>;
    }

    return (
      <span>
        {inputDisplay}
      </span>
    );
  }
}

SelectBox.defaultProps = {
  isEditable: true
};

SelectBox.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  existingContent: PropTypes.string,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  required: PropTypes.bool,
  verticalSpacing: PropTypes.string
}
